export function agoLabel(iso: string | null | undefined): string {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  const dt = (Date.now() - t) / 1000;
  if (dt < 60)        return `${Math.floor(dt)}s ago`;
  if (dt < 3600)      return `${Math.floor(dt / 60)}m ago`;
  if (dt < 86400)     return `${Math.floor(dt / 3600)}h ago`;
  return `${Math.floor(dt / 86400)}d ago`;
}

export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export function formatCurrency(n: number, currency = "EUR"): string {
  return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(n);
}

export function staleness(synced_at: string | null | undefined): "fresh" | "stale" | "very-stale" {
  if (!synced_at) return "very-stale";
  const dt = (Date.now() - new Date(synced_at).getTime()) / 1000;
  if (dt < 600)  return "fresh";
  if (dt < 1800) return "stale";
  return "very-stale";
}
